import { FunctionComponent, memo, useMemo } from "react";

import AnomalyDescriptionItems from "../anomaly-description-items";

import { getMetricNames } from "./metric-anomaly-description.utilities";
import { IProps } from "./metric-anomaly-description.types";
import "./metric-anomaly-description.scss";

/**
 * Give a text description of a metric anomaly. This is just a list of the metric names that triggered it.
 * @param props.anomalyEvents Events that triggered the anomaly.
 * @returns                   Anomaly description.
 */
const MetricAnomalyDescription: FunctionComponent<IProps> = ({ anomalyEvents }) => {
    const metricNames = useMemo(() => getMetricNames(anomalyEvents), [anomalyEvents]);
    return (
        <p>
            Significant change in <AnomalyDescriptionItems items={metricNames} quote={false} />.
        </p>
    );
};

export default memo(MetricAnomalyDescription);
